import { call, put, takeLatest } from "redux-saga/effects"

import { GET_LIST_QUESTIONS_WATCHER } from "./constants"

import {
  getListQuestionsSuccess,
  getListQuestionsFailed,
  getListOnlyQuestionsSuccess,
  getListOnlyQuestionsFailed,
} from "./actions"
import { getListQuestionsApi } from "../../../utils/routes/routes-report"

export function* getListQuestionsSaga(params) {
  try {
    const { measureGeneral } = params.payload

    if (measureGeneral.segments.length === 1) {
      params.payload.id_segment = measureGeneral.segments[0].id_segment
      params.payload.id_survey =
        measureGeneral.segments[0].id_survey || measureGeneral.id_survey
    } else if (measureGeneral.segments.length > 1) {
      // Todos los segmentos de una medicion comparten el id_survey real (los
      // "segmentos" filtran las mismas respuestas, no son encuestas distintas).
      // measureGeneral.segments[].id_survey siempre viene poblado, a diferencia
      // de measureGeneral.id_survey (el backend solo lo resuelve cuando la
      // request trae id_segment) o measureTotal.id_survey (idem, solo poblado
      // para el flag 'SMT', no para el 'MT' de la vista General). Se usa el
      // segmento activo si hay uno seleccionado, o el primero disponible para
      // la vista General (VLENG-11404).
      const activeSegment = params.payload.id_segment
        ? measureGeneral.segments.find(
            (segment) => segment.id_segment === params.payload.id_segment
          )
        : measureGeneral.segments[0]
      params.payload.id_survey =
        (activeSegment && activeSegment.id_survey) || measureGeneral.id_survey
    }

    params.payload.measure_type = measureGeneral.id_measure_type || null

    // Guard: getListQuestionsApi returns undefined when id_survey is 0/falsy
    const response = yield call(getListQuestionsApi, params.payload)
    if (!response) {
      yield put(getListOnlyQuestionsSuccess([]))
      yield put(getListQuestionsSuccess([]))
      return
    }

    const { data: qualitative } = response
    yield put(getListOnlyQuestionsSuccess(qualitative))

    const filterQualitative = qualitative.filter((item) => {
      return item.enabled
    })

    params.payload.question =
      (filterQualitative[0] && filterQualitative[0].id_question) || null

    if (!params.payload.question) {
      yield put(getListQuestionsSuccess([]))
    } else {
      yield put(getListQuestionsSuccess(filterQualitative))
    }
  } catch (e) {
    console.log(e)
    yield put(getListOnlyQuestionsFailed())
    yield put(getListQuestionsFailed())
  }
}

export default function* widgetQualitativeQuestionSaga() {
  yield takeLatest(GET_LIST_QUESTIONS_WATCHER, getListQuestionsSaga)
}
